var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuModelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 2.66634C2.96579 2.66634 2.66732 2.96482 2.66732 3.33301V12.6663C2.66732 13.0345 2.96579 13.333 3.33398 13.333H12.6673C13.0355 13.333 13.334 13.0345 13.334 12.6663V3.33301C13.334 2.96482 13.0355 2.66634 12.6673 2.66634H3.33398ZM1.33398 3.33301C1.33398 2.22844 2.22941 1.33301 3.33398 1.33301H12.6673C13.7719 1.33301 14.6673 2.22844 14.6673 3.33301V12.6663C14.6673 13.7709 13.7719 14.6663 12.6673 14.6663H3.33398C2.22941 14.6663 1.33398 13.7709 1.33398 12.6663V3.33301Z",
    fill: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 5.99967C1.33398 5.63148 1.63246 5.33301 2.00065 5.33301H14.0007C14.3688 5.33301 14.6673 5.63148 14.6673 5.99967C14.6673 6.36786 14.3688 6.66634 14.0007 6.66634H2.00065C1.63246 6.66634 1.33398 6.36786 1.33398 5.99967Z",
    fill: "#7E716D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00065 5.33301C6.36884 5.33301 6.66732 5.63148 6.66732 5.99967V13.9997C6.66732 14.3679 6.36884 14.6663 6.00065 14.6663C5.63246 14.6663 5.33398 14.3679 5.33398 13.9997V5.99967C5.33398 5.63148 5.63246 5.33301 6.00065 5.33301Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuModelIcon);
export default __webpack_public_path__ + "static/media/menu-model-icon.a590cdf550d0cea15f0b8ef04945b0ea.svg";
export { ForwardRef as ReactComponent };